import React from 'react';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { SvgIconProps, Typography } from '@mui/material';
import MUIBreadcrumbs from '@mui/material/Breadcrumbs';
import { Link } from 'react-router-dom';
import { fontSize, palette } from '..';
export interface IBreadcrumb {
  name: string;
  href: string;
  className?: string;
  isCurrent?: boolean;
}

export interface BreadCrumbProps {
  breadcrumbs: IBreadcrumb[];
  separator?: React.ComponentType<SvgIconProps>;
  className?: string;
}

function Breadcrumbs({
  breadcrumbs,
  separator: Separator = NavigateNextIcon,
  className,
}: BreadCrumbProps) {
  return (
    <React.Fragment>
      <MUIBreadcrumbs
        separator={<Separator fontSize="small" />}
        aria-label="breadcrumb"
        className={className}
      >
        {breadcrumbs.map((breadcrumb, index) =>
          breadcrumb.isCurrent ? (
            <Typography key={index} sx={{ fontSize: fontSize.medium, color: palette.primary.contrastText }}>
              {breadcrumb.name}
            </Typography>
          ) : (
            <Link
              key={index}
              to={breadcrumb.href}
              className={breadcrumb.className}
            >
              {breadcrumb.name}
            </Link>
          ),
        )}
      </MUIBreadcrumbs>
    </React.Fragment>
  );
}

export default Breadcrumbs;
